import { FormattedMessage } from "react-intl";
import { closeCurrentPopin, displayPopin } from "../../Hook/popins";
import headerLogo from "./assets/headerLogo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faClose, faFaceSmile, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import subscription from "./assets/subscription.png";
import background from "./assets/background.png";
import background2 from "./assets/background3.png";
import validateunlock from "./assets/validateunlock.png";
import creditcard from "./assets/creditcard.png";
import useIsMobile from "../../Hook/mobile";
import { USER } from "../../Hook/user";

export default function PickValidator() {
  const detect = useIsMobile();
  return <>
    <div onClick={closeCurrentPopin} className="top-0 left-0 right-0 bottom-0 fixed bg-black z-40 opacity-60"></div>
    <div className="z-50 lg:max-w-4xl flex flex-col gap-3 lg:pt-2 pt-4 px-4 pb-4 rounded-t-xl lg:rounded-xl bg-popinbg w-screen fixed max-h-[100dvh] scroll--numbers overflow-y-auto bottom-0 lg:bottom-auto lg:top-1/2 left-1/2 transform -translate-x-1/2 lg:-translate-y-1/2">
      <div className="flex gap-4 items-center lg:mb-0 mb-2">
        <img className=" h-8 w-8" src={headerLogo} alt="18 certified logo" />
        <h2 className="flex-1"><FormattedMessage id="underage__title_validate_majority" /></h2>
        <div onClick={closeCurrentPopin}><FontAwesomeIcon className="h-8 w-8 text-[#F34673]" icon={faClose} /></div>
      </div>
      <div className="flex gap-12 lg:flex-row flex-col">
        <div className="relative flex-shrink-0 flex-1 items-center justify-center">
          <div className="absolute px-4 z-10 top-0 left-0  flex flex-col items-center lg:gap-4 right-0 bottom-0">
            <img alt="" className="lg:w-60 w-40 lg:pt-24 lg:pb-10" src={validateunlock} />
            <div className="text-[#D300EC] text-xl uppercase lg:mt-30"><FormattedMessage id="underage__unlock_options_count" /></div>
            <div className="text-[#003471]"><FormattedMessage id="underage__less_than_2_mn" /></div>
          </div>
          <img alt="" className="w-full h-48 lg:h-full" src={detect.isMobile ? background2 : background} />

        </div>
        <div className="flex-1 flex-shrink-0 flex flex-col gap-4 justify-center">
          <div className="flex-1 flex flex-col gap-2">
            <div className="text-tabs"><FormattedMessage id="underage__option_1" /></div>
            <div onClick={() => {
              displayPopin()("addcard");
              closeCurrentPopin();
            }} className="flex flex-1 border border-cards rounded-xl hover:border-primary cursor-pointer gap-6 overflow-hidden relative items-center px-4 py-8 bg-cards">
              <div className="absolute bshadow top-2/5 left-20 z-0"></div>
              <div className="relative flex-shrink-0 z-10"><img alt="" className="w-32" src={creditcard} /></div>
              <div>
                <h4 className="text-lg text-primary flex justify-between items-center"><FormattedMessage id="underage__credit_card_option" /><FontAwesomeIcon icon={faChevronRight} /></h4>
                <p><FormattedMessage id="underage__credit_card_description" /></p>
              </div>
            </div>
          </div>
          <div className="flex-1 flex flex-col gap-2">
            <div className="text-tabs"><FormattedMessage id="underage__option_2" /></div>
            <div onClick={() => {
              if (USER.informations!.age_verification_url) {
                //open in the same page to avoid popup blockers
                window.location.href = USER.informations!.age_verification_url;
              }
            }} className="flex flex-1 border border-cards rounded-xl hover:border-primary cursor-pointer gap-6 overflow-hidden relative items-center px-4 py-8 bg-cards">
              <div className="absolute bshadow top-2/5 left-20 z-0"></div>
              <div className="relative flex-shrink-0 z-10 w-32">
                <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 36 20" className="w-24 h-24 m-auto">
                <path fill="#00bc2c" d="M22.67 8.21c-.21.43-.51.79-.88 1.1s-.82.53-1.34.69c-.34.1-.53.47-.4.8l3.54 9.19h4.72L36 0h-3.6c-.38 0-.7.1-.97.31-.26.21-.44.44-.53.69 0 0-4.7 14.04-4.93 14.8h-.01c-.06-.38-1.27-3.98-2.48-7.53a.44.44 0 0 0-.81-.05Z"></path>
                <path fill="#004db3" d="M11.42 0H7.65L0 20h3.58c.38 0 .7-.1.96-.31s.44-.44.53-.69c0 0 4.84-14.57 4.91-14.82-.04.16 1.84 5.72 3.29 9.99h-2.14c-.63 0-1.14.51-1.14 1.15v3h4.69c.15.43.23.68.23.68q.15.435.54.72c.26.19.59.28.98.28h3.56L12.35 0z"></path></svg>
              </div>
              <div>
                <h4 className="text-lg text-primary flex justify-between items-center"><FormattedMessage id="underage__age_verif_option" /><FontAwesomeIcon icon={faChevronRight} /></h4>
                <p><FormattedMessage id="underage__age_verif_description" /></p>
              </div>
            </div>

          </div>
          <div className="flex-1 flex flex-col gap-2">
            <div className="text-tabs"><FormattedMessage id="underage__option_3" /></div>
            <div onClick={() => {
              displayPopin()("subscribe");
              closeCurrentPopin();
            }} className="flex flex-1 border border-cards rounded-xl hover:border-primary cursor-pointer gap-6 overflow-hidden relative items-center px-4 py-8 bg-cards">
              <div className="absolute bshadow top-2/5 left-20 z-0"></div>
              <div className="relative  flex-shrink-0 z-10 w-32 flex justify-center"><img alt="" className="h-32 max-w-32" src={subscription} /></div>
              <div>
                <h4 className="text-lg text-primary flex justify-between items-center"><FormattedMessage id="underage__subscription_option" /><FontAwesomeIcon icon={faChevronRight} /></h4>
                <p><FormattedMessage id="underage__subscription_description" /></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}